<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailInvoice" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Produk</div>
									<v-checkbox v-model="detailProduct" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Tanda Tangan</div>
									<v-checkbox v-model="signature" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2" v-if="detailSO.so_status != 'created'">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn text large depressed class="primary col-12 mt-5" @click="printDiv(detailSO.so_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="deep-purple lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5" id="section-to-print" v-if="false">
								<div class="white">
									<div class="text-center">
										<img width="90" src="/assets/icon/milagros-icon.png">
									</div>
									<v-row class="pt-2">
										<v-col cols="3">
											<div v-if="soDate" class="text-body-2 font-weight-bold">Tanggal</div>
											<div v-if="false" class="text-body-2 font-weight-bold pt-2">Pembayaran</div>
											<div v-if="soStatus" class="text-body-2 font-weight-bold pt-2">Status</div>
										</v-col>
										<v-col cols="9" class="pl-0">
											<div v-if="soDate" class="text-body-2">{{ detailSO.so_status_created_datetime | haritanggaljam }}</div>
											<v-layout wrap v-if="false">
												<v-flex xs3>
													<div class="pt-2 pr-1 text-capitalize" v-if="detailSO.so_payment_method == 'cash'">Tunai</div>
													<div class="pt-2 pr-1 text-capitalize" v-else>Transfer Bank</div>
												</v-flex>
												<!-- <v-flex xs3>
													<img class="mt-n1" width="60" src="/assets/bank/bca.svg">
												</v-flex> -->
											</v-layout>
											<div class="pt-2" v-if="soStatus">{{ detailSO.so_status | toStatusSOWH }}</div>
										</v-col>
									</v-row>
									<div class="mt-3" v-if="paySummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th colspan="2" class="text-body-2 black--text text-left font-weight-bold">Ringkasan Pembayaran</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>Total Belanja</td>
															<td class="text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row class="pb-3">
											<v-col cols="6" class="pb-0"></v-col>
											<v-col cols="6" class="pb-0">
												<v-card outlined class="pa-4 deep-purple lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="pb-3">
										<div class="border-topbot-dotted py-3 mt-3">
											<v-row>
												<v-col cols="6" class="pb-0">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2 font-weight-bold">Nomor</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2 font-weight-bold">{{ detailSO.so_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="6">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Atas nama</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSO.so_status_created_user_name }}</span>
														</v-col>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Tanggal</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSO.so_status_created_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="6">
													<v-row>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Nama Mitra</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSO.customer_name }}</span>
														</v-col>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">ID Mitra</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSO.customer_network_mid }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="customerAddress">
										<v-card outlined class="mt-3">
											<v-row class="py-3">
												<v-col cols="6" class="py-0">
													<div class="pl-4 text-body-2 font-weight-bold">Alamat Mitra</div>
													<div class="pl-4 pt-2 text-body-2">{{ addresText }}</div>
												</v-col>
												<v-col cols="6" class="py-0 border-left-grey">
													<div v-if="detailSO.so_status == 'canceled'">
														<div class="pl-4 pt-2 text-body-2">
															<span>Tanggal Pembatalan :</span>
															<span class="pl-2">{{ detailSO.so_status_canceled_datetime | tanggal }}</span>
														</div>
													</div>
													<div v-else>
														<v-row>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Bayar</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailSO.so_status_paid_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Approve</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailSO.so_status_approved_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Proses</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailSO.so_status_processed_datetime | tanggal }}</span>
																</div>
															</v-col>
														</v-row>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="mt-3" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Jumlah</th>
															<th class="text-center">Berat</th>
															<th class="text-right">Harga(Rp)</th>
															<th class="text-right">Subtotal(Rp)</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailSO.so_detail" :key="product.so_detail_id">
															<td class="text-left">{{ product.so_detail_product_name }}</td>
															<td class="text-center">
																<div>{{ product.so_detail_quantity_sold | toNumber }}  {{product.so_detail_product_unit}}</div>
															</td>
															<td class="text-center">{{ product.so_detail_product_weight | toKg }}</td>
															<td class="text-right">{{ product.so_detail_product_price | toNumber }}</td>
															<td class="text-right">{{ product.so_detail_product_price * product.so_detail_quantity_sold | toNumber }}</td>
														</tr>
														<tr>
															<td colspan="4" class="font-weight-bold text-right">Total Harga</td>
															<td class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row>
											<v-col cols="6"></v-col>
											<v-col cols="6">
												<v-card outlined class="pa-4 deep-purple lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="mt-3" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div class="pt-2 text-body-2">
											<div v-if="detailSO.so_note">{{ detailSO.so_note }}</div>
											<div v-else>Tidak ada catatan</div>
										</div>
									</div>
								</div>
							</v-card>
							<v-card elevation="10" tile class="pa-5" v-if="detailSO.so_status == 'created'">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="9" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="3" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1">INVOICE</div>
													</div>
													<div class="text-right" v-if="false">
														<div class="font-size-8">
															email: nbudijatmiko@gmail.com
														</div>
														<div class="font-size-8">
															web: https://mobile-counter-stockist.esoftdream.co.id
														</div>
													</div>
													<div class="d-flex align-center ml-4" v-if="false">
														<img width="60" height="60" src="/assets/icon/qr-code.png">
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<v-row v-if="detailInvoice">
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Nomor</div>
													<div>Tanggal</div>
													<div>MC ID</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div>: {{ detailSO.so_code }}</div>
													<div>: {{ detailSO.so_status_created_datetime | tanggaljam }}</div>
													<div>: {{ detailSO.customer_network_code }}</div>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Kepada</div>
													<div>Telepon</div>
													<div>Alamat</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.customer_name }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.customer_mobilephone }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ addresText }}</div>
													</div>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
									<div class="pt-3" v-if="detailProduct">
										<v-card elevation="0" tile>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="pr-0 text-left border-left">
																<div class="font-size-9">No</div>
															</th>
															<th class="text-left">
																<div class="font-size-9">Nama Produk</div>
															</th>
															<th class="text-right">
																<div class="font-size-9">Harga</div>
															</th>
															<th class="text-center">
																<div class="font-size-9">Qty</div>
															</th>
															<th class="text-center">
																<div class="font-size-9">Satuan</div>
															</th>
															<th class="text-right border-right">
																<div class="font-size-9">Subtotal</div>
															</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="( product, index) in detailSO.so_detail" :key="product.so_detail_id">
															<td class="pr-0 text-left border-left">
																<div class="font-size-9">{{ index + 1 }}.</div>
															</td>
															<td class="text-left">
																<div class="font-size-9">{{ product.so_detail_product_name }}</div>
															</td>
															<td class="text-right">
																<div class="font-size-9">{{ product.so_detail_product_price | toNumber }}</div>
															</td>
															<td class="text-center">
																<div class="font-size-9">{{ product.so_detail_quantity_sold | toNumber }}</div>
															</td>
															<td class="text-center">
																<div class="font-size-9">{{product.so_detail_product_unit}}</div>
															</td>
															<td class="text-right border-right">
																<div class="font-size-9">{{ (product.so_detail_product_price * product.so_detail_quantity_sold) | toNumber }}</div>
															</td>
														</tr>
														<tr>
															<td colspan="5" class="text-right border-left">
																<div class="pr-4 font-size-9 grey--text text--darken-2 font-weight-bold">Total</div>
															</td>
															<td colspan="5" class="text-right border-right">
																<div class="font-size-9 grey--text text--darken-2 font-weight-bold">{{ grandTotal | toNumber }}</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-3" v-if="signature">
										<div class="d-flex justify-end">
											<v-col cols="5" class="px-0 pb-0">
												<div class="text-center font-size-9">
													<div class="pb-5">Hormat Kami,</div>
													<div class="pt-5">(Admin {{ userData.warehouse_name }})</div>
												</div>
											</v-col>
										</div>
									</div>
								</div>
							</v-card>
							<v-card elevation="10" tile class="pa-5" v-else>
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="7" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="5" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-1 py-1 text-uppercase">Bukti pembayaran</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<v-row v-if="detailInvoice">
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Nomor</div>
													<div>Tanggal</div>
													<div>MC ID</div>
													<div>Bayar</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.so_code }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.so_status_paid_datetime | tanggaljam }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.customer_network_code }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div>
															<div class="pl-1" v-if="detailSO.so_payment_note" v-html="detailSO.so_payment_note"></div>
															<div class="pl-1" v-else>-</div>
														</div>
													</div>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Kepada</div>
													<div>Telepon</div>
													<div>Alamat</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.customer_name }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSO.customer_mobilephone }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ addresText }}</div>
													</div>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
									<div class="pt-3" v-if="detailProduct">
										<v-card outlined tile>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left border-left" width="6%">No</th>
															<th class="text-left">Nama Produk</th>
															<th class="text-right">Harga</th>
															<th class="text-center">Qty</th>
															<th class="text-center">Satuan</th>
															<th class="text-right border-right">Subtotal</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="( product, index) in detailSO.so_detail" :key="product.so_detail_id">
															<td class="text-left border-left">
																<div class="font-size-9">{{ index + 1 }}.</div>
															</td>
															<td class="text-left">
																<div class="font-size-9">{{ product.so_detail_product_name }}</div>
															</td>
															<td class="text-right">
																<div class="font-size-9">{{ product.so_detail_product_price | toNumber }}</div>
															</td>
															<td class="text-center">
																<div class="font-size-9">{{ product.so_detail_quantity_sold | toNumber }}</div>
															</td>
															<td class="text-center">
																<div class="font-size-9">{{product.so_detail_product_unit}}</div>
															</td>
															<td class="text-right border-right">
																<div class="font-size-9">{{ (product.so_detail_product_price * product.so_detail_quantity_sold) | toNumber }}</div>
															</td>
														</tr>
														<tr>
															<td colspan="5" class="text-right border-left">
																<div class="pr-4 font-size-9 grey--text text--darken-2 font-weight-bold">Total</div>
															</td>
															<td colspan="5" class="text-right border-right">
																<div class="font-size-9 grey--text text--darken-2 font-weight-bold">{{ grandTotal | toNumber }}</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-3" v-if="signature">
										<div class="d-flex justify-end">
											<v-col cols="5" class="px-0">
												<div class="text-center font-size-9">
													<div class="pb-5">Hormat Kami,</div>
													<div class="pt-5">( Admin {{ userData.warehouse_name }} )</div>
												</div>
											</v-col>
										</div>
									</div>
									<div v-if="note">
										<div class="pt-3 font-size-9 font-italic">Catatan : Bukti pembayaran ini harap disimpan***</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			detailInvoice: true,
			detailProduct: true,
			signature: true,
			note : true,
		}
	},
	computed: {
		...mapState('so', ['detailSO']),
		...mapState('common', ['letterHeader']),
		...mapState('auth', ['userData']),

		addresText() {
			var data = []
			if (this.detailSO) {
				if (this.detailSO.customer_address)
					data.push(this.detailSO.customer_address)
				if (this.detailSO.customer_subdistrict_name)
					data.push(this.detailSO.customer_subdistrict_name)
				if (this.detailSO.customer_city_name)
					data.push(this.detailSO.customer_city_name)
				if (this.detailSO.customer_province_name)
					data.push(this.detailSO.customer_province_name)
			}
			return data.join(', ')
		},
		grandTotal(){
			let total = 0
			if (this.detailSO.so_detail) {
				this.detailSO.so_detail.forEach( (el) => {
					total += el.so_detail_product_price * el.so_detail_quantity_sold
				});
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		}
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.detailInvoice = true
				this.detailProduct = true
				this.signature = true
				this.note  = true
			}
		}
	},
};
</script>